import { useState, useEffect, useRef } from "react";

const GPS_THRESHOLD_MINUTES = 30;

export interface GpsSessionTimer {
  gpsActiveMinutes: number;
  hasReachedThreshold: boolean;
}

export function useGpsSessionTimer(isWatching: boolean): GpsSessionTimer {
  const [minutesAccumulated, setMinutesAccumulated] = useState(0);
  const [debugBypass, setDebugBypass] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  // Debug bypass: ?feedback_debug=1 in DEV mode (one-time check)
  useEffect(() => {
    if (import.meta.env.DEV && typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      if (params.get("feedback_debug") === "1") {
        setDebugBypass(true);
      }
    }
  }, []);

  useEffect(() => {
    if (isWatching) {
      intervalRef.current = setInterval(() => {
        setMinutesAccumulated((prev) => prev + 1);
      }, 60_000);
    } else if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isWatching]);

  return {
    gpsActiveMinutes: minutesAccumulated,
    hasReachedThreshold: debugBypass || minutesAccumulated >= GPS_THRESHOLD_MINUTES,
  };
}
